module.exports = __webpack_public_path__ + "static/media/delete.3c4d36f4.svg";